import React, { useState, useEffect } from 'react'
import { Title, usePermissions } from 'react-admin';
import { DataGridPro } from '@mui/x-data-grid-pro';


import {
   faIR,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarDensitySelector,

} from '@mui/x-data-grid';

import Box from '@mui/material/Box';
import { SERVER } from '../../constants';
import { AUTH_TYPES } from '../../auth/authConstants';
import * as XLSX from 'xlsx';

import { ROLES } from '../../constants';



//   //totla TODO
//   // {
//   //   field: 'total',
//   //   headerName: 'مجموع',
//   //   sortable: false,
//   //   width: 160,
//   //   valueGetter: (params) =>
//   //     `${params.row['شعبه مطهری'] || ''} + ${params.row['شعبه ۵ رمضان'] || ''}`,
//   // },
// ];

function CustomToolbar() {
  const { permissions } = usePermissions();

  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />
      {((permissions?.includes(ROLES.SUPER_ADMIN) ||
        permissions?.includes(ROLES.USERS_ADMIN) ||
        permissions?.includes(ROLES.ANBAAR_ADMIN) ||
        permissions?.includes(ROLES.SALE_ADMIN))) &&
        <GridToolbarExport />}
    </GridToolbarContainer>
  );
}


export const ReportStatComponent = () => {
  const { permissions } = usePermissions();

  const [gridDate, setGridData] = useState({ columns: [], rows: [] })
  const [endpointCalled, setEndpointCalled] = useState(false);
  const pinnedRows = {
    top: [{ id: 0 }],
  };
  function downloadExcel() {
    let headerName = gridDate.columns.map(a => a.headerName)
    delete headerName[0];
    delete headerName[headerName.length - 1];
    var Heading = [headerName];
    let arr = gridDate.rows;
    arr.forEach(object => {
      delete object['id'];
      // delete object['مجموع'];

    });
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet([]);
    XLSX.utils.sheet_add_aoa(ws, Heading);

    //Starting in the second row to avoid overriding and skipping headers
    XLSX.utils.sheet_add_json(ws, arr, { origin: 'A2', skipHeader: true });

    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, "-گزارش موجودی بخش ها.xlsx");

  }
  setTimeout(function () {

    var searchText = "MUI X: Missing license key";
    var found;

    var aTags = document.getElementsByTagName("div");
    for (var i = 0; i < aTags.length; i++) {
      if (aTags[i].textContent === searchText) {
        found = aTags[i];
        break;
      }
    }
    //check if found is not undefined then change style.display to "none";
    if (found)
      found.style.display = "none";


  }, 50);


  useEffect(() => {
    const token = localStorage.getItem(AUTH_TYPES.AUTHORIZATION);
    const url = `${SERVER}/admin/reportstat`;
    fetch(url, {
      headers: new Headers({
        'Authorization': `${token}`,
      }),

    })
      .then((data) => data.json())
      // .then((data) => setTableRows(data.rows))
      .then((data) => setGridData(data))
      // .then((data) => tableColumns= data.columns)
      .then(setEndpointCalled(true))

  }, [])
  return (


    <Box dir="ltr" sx={{
      height: '100%', width: '100%', '& .cold': {
        backgroundColor: '#b9d5ff91',
        color: '#1a3e72',
      },
      '& .hot': {
        backgroundColor: '#ff943975',
        color: '#1a3e72',
      },
    }} >
      <Title title="تحلیل گزارش" />
      {/* {(permissions?.includes(ROLES.SUPER_ADMIN || permissions?.includes(ROLES.USERS_ADMIN || permissions?.includes(ROLES.ANBAAR_ADMIN || permissions?.includes(ROLES.SALE_ADMIN) && <ReferenceInput variant="outlined" label=" پردازنده" source="unitId" reference="unit" >
        <SelectInput optionText="title" />
      </ReferenceInput>} */}
      {((permissions?.includes(ROLES.SUPER_ADMIN) || permissions?.includes(ROLES.USERS_ADMIN) || permissions?.includes(ROLES.ANBAAR_ADMIN) || permissions?.includes(ROLES.SALE_ADMIN))
        && endpointCalled) ?

        <button className="p-2 border-2 border-teal-500 m-4" onClick={() => downloadExcel()}>
          دریافت فایل خروجی موجودی
        </button>

        // <ReactHTMLTableToExcel
        //   id="table-xls-button"
        //   className="download-table-xls-button"
        //   table="table-to-xls"
        //   filename="export-report"
        //   sheet="export"
        //   buttonText="دریافت فایل خروجی"
        // />
        : null}

      {endpointCalled ?
        <DataGridPro
          experimentalFeatures={{ rowPinning: true }}
          pinnedRows={pinnedRows}
          zIndex="1"
          id="table-to-xls"
          rows={gridDate.rows}
          columns={gridDate.columns}
          loading={!gridDate.columns}
          pageSize={100}
          rowsPerPageOptions={[500]}
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          components={{
            Toolbar: CustomToolbar,
          }}
          initialState={{ pinnedColumns: { left: ['کالا'] } }}
          getRowClassName={(params) => {
            if (params.indexRelativeToCurrentPage === 0)
              return 'cold'
          }}

        /> : null}
    </Box >

  )
};

